import React from 'react';
import ContentLoader from 'react-content-loader';
import VisuallyHidden from '@reach/visually-hidden';

const GiftLoader = () => (
  <>
    <VisuallyHidden>Gift Loader</VisuallyHidden>
    <ContentLoader
      speed={2}
      viewBox="0 0 1000 500"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="120" y="55" rx="13" ry="13" width="320" height="28" />
      <rect x="120" y="115" rx="13" ry="13" width="320" height="28" />
      <rect x="120" y="175" rx="13" ry="13" width="320" height="28" />
      <rect x="120" y="236" rx="13" ry="13" width="320" height="28" />
    </ContentLoader>
  </>
);

export default GiftLoader;
